
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './ed-ing-explanation';
const mainimage = '/Images/eding1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "eding" },
];


const EdIng = () => (
  <GrammarPageLayout
    level="B1"
    title="Ed Ing"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Verb Forms: -ed and -ing Exercises"
    seoDescription="Learn the difference between -ed and -ing adjectives (bored vs. boring). B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default EdIng;
